import ErrorBackground from '@ifca-root/react-component/src/assets/images/error-404-dark.jpg';
import { AuthLayout } from '@ifca-root/react-component/src/components/AuthLayout/AuthLayout';
import { Button } from '@material-ui/core';
import Logo from 'assets/images/MenuX-Logo.svg';
import useStyles from 'containers/AccountModule/useStyles';
import React from 'react';
import { useHistory } from 'react-router';

export const InvalidQR = props => {
	const classes = useStyles({});
	let history = useHistory();
	return (
		<AuthLayout logo={Logo} image={ErrorBackground} className="margin-override">
			<br />
			<div className={classes.root}>
				<div style={{ textAlign: 'center' }}>
					<div className="m-b-20">
						<h1 className={classes.h1}>Whoops!</h1>
						{/* <br />
            <h4 className={classes.h2}>Page Not Found!</h4> */}
						<span className={classes.h3}>This QR is not valid</span>
					</div>

					{/* <Button
						variant="contained"
						color="primary"
						className=""
						onClick={() => history.goBack()}
					>
						Back to home
					</Button> */}
				</div>
			</div>
		</AuthLayout>
	);
};
